/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Native_Release_Widget_Week_To_GoInputs */

const en_us2_native_release_widget_week_to_go = /** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} to go`)
};

const pt_br2_native_release_widget_week_to_go = /** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faltam ${i?.count}`)
};

const pt_pt2_native_release_widget_week_to_go = /** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faltam ${i?.count}`)
};

/** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */
const es_419_native_release_widget_week_to_go = en_us2_native_release_widget_week_to_go;

/** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */
const fr_fr2_native_release_widget_week_to_go = en_us2_native_release_widget_week_to_go;

/** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */
const de_de2_native_release_widget_week_to_go = en_us2_native_release_widget_week_to_go;

/** @type {(inputs: Native_Release_Widget_Week_To_GoInputs) => LocalizedString} */
const it_it2_native_release_widget_week_to_go = en_us2_native_release_widget_week_to_go;

/**
* | output |
* | --- |
* | "{count} to go" |
*
* @param {Native_Release_Widget_Week_To_GoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_week_to_go = /** @type {((inputs: Native_Release_Widget_Week_To_GoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Week_To_GoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_week_to_go(inputs)
	if (locale === "es-419") return es_419_native_release_widget_week_to_go(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_week_to_go(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_week_to_go(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_week_to_go(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_week_to_go(inputs)
	return en_us2_native_release_widget_week_to_go(inputs)
});
export { native_release_widget_week_to_go as "native-release.widget_week_to_go" }